import VueRouter from 'vue-router';
const _routes = [
    {
        path: '/',
        redirect: '/fr'
    },   
    {
        path: '/:locale',
        component: () => import('./App.vue' /*webpackChunkName: "app"*/),
        name: 'app',
    },
    {
        path: '/:locale/map/:farmerSlug',
        component: () => import('./components/pages/FarmersMap.vue', /*webpackChunkName: "map"*/),
        name: 'map',
    },    
    {
        path: '/:locale/map',
        component: () => import('./components/pages/FarmersMap.vue', /*webpackChunkName: "map"*/),
        name: 'map',
    },            
]

var router = new VueRouter({
    mode: 'history',
    base: __dirname,
    routes: _routes,
    linkActiveClass: 'active'
})

export default router



// WEBPACK FOOTER //
// ./src/routes.js